import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategoryNav() {
  return (
    <section className="w-full bg-background-50 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            视频分类
          </h2>
          <Link
            to="/category/dianshi"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-background-50 group-hover:bg-primary-100 transition-colors mb-3">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-500`}></i>
              </div>
              <span className="text-sm md:text-base font-semibold text-foreground-800 mb-1">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">{cat.count} 部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}